import React from 'react';

import avatarComponent from './icons/avatar-components';
import avatarContent from './icons/avatar-content';
import avatarFoundations from './icons/avatar-foundations';
import avatarGetStarted from './icons/avatar-get-started';
import avatarPatterns from './icons/avatar-patterns';
import avatarResources from './icons/avatar-resources';
import avatarTokens from './icons/avatar-tokens';

const CATEGORY_NAMES = {
	GET_STARTED: 'get started',
	FOUNDATIONS: 'foundations',
	COMPONENTS: 'components',
	CONTENT: 'content',
	PATTERNS: 'patterns',
	RESOURCES: 'resources',
	LICENSE: 'license',
	TOKENS: 'tokens',
};

const getIcon = (heading: string = '') => {
	switch (heading.toLowerCase()) {
		case CATEGORY_NAMES.TOKENS:
			return avatarTokens;
		case CATEGORY_NAMES.COMPONENTS:
			return avatarComponent;
		case CATEGORY_NAMES.CONTENT:
			return avatarContent;
		case CATEGORY_NAMES.FOUNDATIONS:
			return avatarFoundations;
		case CATEGORY_NAMES.RESOURCES:
			return avatarResources;
		case CATEGORY_NAMES.PATTERNS:
			return avatarPatterns;
		case CATEGORY_NAMES.GET_STARTED:
			return avatarGetStarted;
	}
};

interface HeadingIconProps {
	heading: string;
}

export default function HeadingIcon({ heading }: HeadingIconProps): React.JSX.Element {
	const Glyph = getIcon(heading);
	return Glyph ? <Glyph aria-label="" /> : <></>;
}
